'use client'

import { authFetch } from '@/lib/auth/auth-fetch'
import { useMutation, useQueryClient } from '@tanstack/react-query'

/**
 * Converts SPOT USDH → SPOT USDC via an agent-signed market SELL on the
 * @230 (USDH/USDC) pair. Reverse of useHyperliquidUsdcToUsdh.
 *
 * Used by the bridge-from-HL flow: when the user wants to withdraw funds
 * that sit on spot USDH (not perp), we sell to USDC first, transfer to
 * perp, then withdraw3.
 *
 * Agent-signed (L1 action) — no fresh user signature required.
 */
export function useHyperliquidUsdhToUsdc() {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: async (input: { usdhAmount: string }) => {
			const r = await authFetch('/api/hyperliquid/usdh-to-usdc', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ usdhAmount: input.usdhAmount }),
			})
			if (!r.ok) {
				const e = (await r.json().catch(() => ({}))) as { error?: string }
				throw new Error(e.error || `convert ${r.status}`)
			}
			return r.json()
		},
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ['hl-balance'] })
		},
	})
}
